import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
// import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { getFileType } from "src/helpers/common";

const VIEWER_HEIGHT = "290";
const VIEWER_WIDTH = "100%";

const LecturePlayer = ({ lectureUrl, classname = "" }) => {
  const { t } = useTranslation();

  const fileType = getFileType(lectureUrl);

  if (!lectureUrl) {
    return (
      <Box sx={{ height: 60 }}>
        <Typography
          fontWeight="bold"
          variant="subtitle1"
          className="align-center"
        >
          {t("course.lectures.noLectureSelected")}
        </Typography>
      </Box>
    );
  }

  switch (fileType) {
    case "video":
      return (
        <video controls width={VIEWER_WIDTH} height={VIEWER_HEIGHT}>
          <source src={lectureUrl} />
        </video>
      );
    case "audio":
      return (
        <audio controls>
          <source src={lectureUrl} />
        </audio>
      );
    case "document":
      return (
        <Box position={"relative"}>
          <iframe
            frameBorder={"0"}
            title={lectureUrl}
            width={VIEWER_WIDTH}
            className={classname}
            height={VIEWER_HEIGHT}
            allow="clipboard-read; clipboard-write"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            src={`https://docs.google.com/gview?url=${lectureUrl}&embedded=true`}
            // src={`https://docs.google.com/viewer?url=${lectureUrl}&embedded=true`}
          />
          {/* {setQuestionData ? (
            <IconButton
              onClick={handleSelection}
              sx={{ position: "absolute", bottom: 5, right: 5 }}
            >
              <ContentCopyIcon />
            </IconButton>
          ) : null} */}
        </Box>
      );

    default:
      return (
        <Box sx={{ height: 60 }}>
          <Typography
            fontWeight="bold"
            variant="subtitle1"
            className="align-center"
          >
            {t("course.lectures.invalidLectureFile")}
          </Typography>
        </Box>
      );
  }
};

export default LecturePlayer;
